import { render } from "./Ticket.vue?vue&type=template&id=1c7f1004&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"

import "./Ticket.vue?vue&type=style&index=0&id=1c7f1004&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c7f1004"

export default script